import axios from "axios";
import { getToken } from "@/utils/authHelpers";
import { API_BASE_URL } from "@/utils/api";
import { StudyDataType } from "@/types/apiTypes";

export const fetchSingleStudyApi = async (
  studyId: string,
): Promise<StudyDataType> => {
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");

  const response = await axios.get<StudyDataType>(
    `${API_BASE_URL}/get-study/${studyId}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};
